import React, { Component } from 'react';

import styled from 'styled-components';
import { SectionChild } from '../components/section';
import ManagedComponent from '../components/managed-component'
import theme from '../themes';

const ToggleWrapper = styled.div`
  background-color: white;  
  border: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0;
  height: 19px;
  width: 100%;
  ${theme.ToggleWrapper}
`;

const ToggleInput = styled.input`
  width: 52px;
  border-radius: 17px;
  box-sizing: border-box;
  height: 32px;
  background: ${({checked}) => checked ? '#4cd964;' : '#e5e5e5;'}
  z-index: 0;
  margin: 0;
  padding: 0;
  appearance: none;
  border: none;
  cursor: pointer;
  position: relative;
  top: -6px;
  transition-duration: .3s;

  &:after {
    content: ' ';
    height: 28px;
    width: 28px;
    border-radius: 28px;
    background: #fff;
    position: absolute;
    z-index: 2;
    top: 2px;
    left: 2px;
    box-shadow: 0 2px 5px rgba(0,0,0,.4);
    transform: ${({checked}) => checked ? 'translateX(20px);' : 'translateX(0);'}
    transition-duration: .3s;
  }
`;

class Toggle extends Component {
  static _type = 'Toggle';
  _type = 'Toggle';

  static defaultProps = {
    value: false
  };

  onChange = ({ currentTarget: { checked } }): void => {
    const { onChange } = this.props;
    if (typeof onChange === 'function') {
      onChange(checked);
    }
  };

  render() {
    const { label, value } = this.props;

    return (
      <SectionChild>
        <ToggleWrapper>
          <div>{label}</div>
          <div>
            <ToggleInput type="checkbox" checked={value} onChange={this.onChange}/>
          </div>
        </ToggleWrapper>
      </SectionChild>
    );
  }
}

export default class extends Component {
  parseValue(rawValue) {
    return rawValue === 'true';
  }

  render() {
    const {
      label,
      value,
      onChange,
      settingsKey
    } = this.props;

    const toggleProps = {
      label,
      value,
      onChange
    };

    if (!settingsKey) {
      return (
        <Toggle {...toggleProps} />
      );
    }

    return (
      <ManagedComponent settingsKey={settingsKey}>
        {({ value, onChange }) => (
          <Toggle
            {...toggleProps}
            value={this.parseValue(value)}
            onChange={(checked) => {
              if (typeof toggleProps.onChange === 'function') {
                toggleProps.onChange(checked);
              }
              onChange(JSON.stringify(checked));
            }}
          />
        )}
      </ManagedComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/toggle.js